module.exports = __webpack_public_path__ + "static/st2-4-b532fbf8c53aabea8b0bab0ee9861133.jpg";